import { Link } from "react-router-dom";
import { ActionType, ILinkProps, TableColumn } from "../../../Component/Model/Table/Table";
import { Typography } from "@mui/material";
import { ClientScorecard } from "../../../Component/Model/Dto/Advisory/ClientScorecard";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { DateFormatter } from "../../../Component/Model/helpers";
import config from "../../../config";
import { useRecoilValue } from "recoil";
import { userRolesState } from "../../../State/user.Atom";
import { AdvancedSupplierModuleRole, AdvisoryRole } from "../../../Component/Common/Constants/UserRoles";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";

interface ClientScorecardRows {
    scorecardId: string;
    name: ILinkProps;
    scorecardType: string;
    createdDate: string;
    isConsolidated: string;
    fromDate: string;
    toDate: string;
    actions: ActionType[];
}

interface ClientScorecardTable {
    columns: Array<TableColumn>;
    rows: Array<ClientScorecardRows>;
}

export function ClientScorecardDataTableColumns(results: ClientScorecard[], handleAdvisoryReport: (scorecardId: string, scorecardName: string, registrationId: string) => void): ClientScorecardTable {
    const userRoles = useRecoilValue(userRolesState);

    function getActionsColumn(item: ClientScorecard, index: number) {
        const actions: ActionType[] = [];

        if (userRoles.includes(AdvisoryRole)) {
            actions.push({
                key: `assign_${index}`,
                label: 'Create Advisory Report',
                action: () => {
                    handleAdvisoryReport(item.scorecardId, item.scorecardName, item.registrationId);
                },
                icon: {
                    color: 'primary',
                    name: 'create_new_folder' 
                },
            });  
        }

        return actions;
    }

    const handleLinkClick = (item: ClientScorecard) => {
        if (userRoles.includes(AdvancedSupplierModuleRole)){
            window.location.href = (`${config.publicUrl}/#scorecard/${item.scorecardId}/dashboard/procurementDashboard`);   
        }
        else {
            window.location.href = (`${config.publicUrl}/#scorecard/${item.scorecardId}/dashboard`);   
        }
    };

    const columns : Array<TableColumn> = [
        { Header: 'Name', accessor: 'name', id: "scorecardName", Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" component={Link} to={value.linkTo}>{value.itemName}</Typography> },
        { Header: 'Scorecard Type', accessor: 'scorecardType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created Date', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Consolidated Scorecard', accessor: 'isConsolidated', id: "consolidated", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'From Date', accessor: 'fromDate', id: "startDate", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'To Date', accessor: 'toDate', id: "endDate", Cell: ({ value }: any) => <DefaultCell value={value} />},
    ];

    if (userRoles.includes(AdvisoryRole)) {
        columns.push({ Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true });
    }

    if (results.length > 0) {
        const rows = results.map((item: ClientScorecard, index: number) => ({
            scorecardId: item.scorecardId,
            name: {
                linkTo: `/bee/scorecardLicense`, itemName:
                    (
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLinkClick(item)}
                        >
                            {item.scorecardName}
                        </div>
                    )
            },
            scorecardType: item.scorecardType,
            createdDate: DateFormatter(item.createdDate.toString()),
            isConsolidated: item.isConsolidated ? 'Yes' : 'No',
            fromDate: DateFormatter(item.startDate.toString()),
            toDate: DateFormatter(item.endDate.toString()),
            registrationId: item.registrationId,
            actions: getActionsColumn(item, index)
        }));

        
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }

    
    
    

}

